import { jsx as _jsx } from "react/jsx-runtime";
import { useFarbwelt } from "@/hooks/useFarbwelt";
import { Box } from "@gemini/core";
import { BuildingFilledIcon } from "@gemini/icons";
import { Avatar } from "@gemini/ui";
export const FarbweltLogo = ({ size = "64", testId, position = "absolute", }) => {
    const { logo, providerName } = useFarbwelt();
    const FallbackIcon = () => _jsx(BuildingFilledIcon, {});
    const label = providerName || "Avatar";
    return (_jsx(Box, { zIndex: "zIndex.1", position: position, backgroundColor: logo ? "color.surface.default.default" : "color.surface.light.default", borderRadius: "radius.8", testId: testId, children: !logo ? (_jsx(Avatar, { icon: FallbackIcon, label: label, size: size, testId: `${testId}.FallbackIcon` })) : (_jsx(Avatar, { imageUrl: logo.src, imageFit: "contain", label: label, size: size, testId: `${testId}.Avatar` })) }));
};
